import { css } from 'styled-components';
import { Component, Decision, getComponentToken, TypographyVariant } from '@optimus-web/local-tokens';
import { Inverse, Secondary, TypographyOptions } from './types';

export const getTypographyOptions = (props: TypographyOptions) => css`
    ${props.align && `text-align: ${props.align};`}
    ${props.noWrap && 'white-space: nowrap;'}
    ${props.overflowWrap && `overflow-wrap: ${props.overflowWrap};`}
    ${props.wordBreak && `word-break: ${props.wordBreak};`}
`;

const getTypographyToken = getComponentToken(Component.Typography);

export const getTypographyColorToken = ({ variant }: { variant?: TypographyVariant } = {}) =>
    getTypographyToken(Decision.Color, { variant });

export interface Ellipticable {
    ellipsis?: boolean;
    maxLines?: number;
}

export const getEllipticableCss = (props: Ellipticable) =>
    props.ellipsis
        ? css`
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;

              ${props.maxLines &&
              css`
                  /* stylelint-disable-next-line value-no-vendor-prefix */
                  display: -webkit-box;
                  /* stylelint-disable-next-line property-no-vendor-prefix */
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: ${props.maxLines};
                  @supports (-webkit-line-clamp: 2) {
                      white-space: normal;
                  }
              `}
          `
        : '';

type getVariantProps = Secondary & Inverse;
export const getVariant = ({ secondary, inverse }: getVariantProps) => {
    if (inverse) {
        return 'inverse';
    }
    if (secondary) {
        return 'secondary';
    }
    return undefined;
};
